





























































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'

export default Vue.extend({
  components: {
    CCard,
    CCollapse,
    PlusMinusCollapseOpener
  },
  data() {
    return {
      icons: {
        chevronUp: faChevronUp
      }
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      isDealer: 'isOfTypeDealer'
    }),
    ...mapDeps({
      legacyUrlService: LegacyUrlService
    })
  },
  methods: {
    getLang() {
      return this.$i18n.locale
    }
  }
})
